<template>
    <div class="body-panel">
        <div class="body-panel-content">
            <div class="body-panel-content-start flex">
                <div class="login-page-bg">
                </div>
                <div class="login-page">
                    <div class="login-logo" v-if="info.Image != null">
                        <img class="login-logo-img" :src="'/uploads/projects/' + (info.StartImage ? info.StartImage: info.Image)" />
                    </div>
                    <div class="login">
                        <template v-if="result == null">
                            <div class="form-header">
                                Восстановление пароля
                            </div>
                            <div class="auth-content-block">
                                Введите email, указанный при регистрации
                            </div>
                            <div class="form-field margin-top-20">
                                <input class="input-text" id="Email" name="Email" placeholder="Email" type="text"
                                       v-validate="'required'"
                                       v-model="Email"
                                       data-vv-as="Email"
                                       :class="['input-text', {'input-error': errors.has('Email')}]"
                                       @input="error = null" />
                                <span class="field-validation-valid">{{ errors.first('Email') }}{{error}}</span>
                            </div>
                            <div class="form-actions">
                                <!--<router-link to="/login" class="forgot-sign-in">Авторизация</router-link>-->
                                <div class="form-btns">
                                    <button type="button" class="btn btn-primary auth" @click="recover()">
                                        Восстановить
                                    </button>
                                </div>
                            </div>
                            <div class="reglink margin-top-20">
                                <p>Вспомнили пароль? <span @click="$router.push('/login')">Войти</span></p>
                            </div>
                        </template>
                        <template v-if="result != null">
                            <div class="auth-content-block margin-bottom-20">
                                Инструкции отправлены на email
                            </div>

                            <router-link to="/login" class="btn btn-primary">Авторизация</router-link>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <vue-headful title="Забыли пароль?" />
    </div>
</template>

<script>
  import UI from '../helpers/ui-helpers'
  import BackendApi from '../backendApi'

  let backendApi = new BackendApi();


  export default {
      name: "forgot-password",

      props: ['info'],

      data(){
          return{
              Email: null,
              error: null,
              result: null
          }
      },

      methods: {
            recover(){
                let vm = this;
                vm.result = null;
                this.$validator.validate().then(result => {
                    if (result) {
                        backendApi.userRecover(vm.Email).then(function (response) {
                            console.info('backendApi.userRecover, response:', response);

                            if (response.hasError) {
                                if(response.status === 1404){
                                    vm.error = 'Указанный email не найден';
                                }
                                else{
                                    UI.toastr.error('Ошибка при восстановлении логина');
                                }
                            }
                            else {
                                if (response.data != null) {
                                    vm.result = response.data;
                                }
                            }
                        });
                    }
                });

            }
      }

  }
</script>

<style scoped="">

</style>


// WEBPACK FOOTER //
// Content/src/views/ForgotPassword.vue